import { createContext, useContext, useEffect, useReducer } from "react";
import { getCountries, getUserLocation, SubscribeAsync } from "../services";

const APIContext = createContext();

const initForm = {
  apiKey: "fQGd1bA1iMjiiU2C5kUZ",
  list: "9763Gg3yOQtIhdXLwe6rvHUA",
  name: "",
  email: "",
  country: "",
};

const initOptions = {
  error: null,
  success: false,
  onSubmission: false,
};

const INITIAL_STATE = {
  countries: [],
  subscribeForm: Object.assign({}, initForm),
  options: Object.assign({}, initOptions),
};

const apiReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_COUNTRIES":
      return {
        ...state,
        countries: payload,
      };
    case "UPDATE_SUBSCRIBE_FORM":
      return { ...state, subscribeForm: payload };

    case "UPDATE_OPTIONS":
      return { ...state, options: payload };

    case "RESET_FORM":
      return {
        ...state,
        subscribeForm: Object.assign({}, initForm),
        options: Object.assign({}, initOptions),
      };

    default:
      throw new Error(`ERROR`);
  }
};

export const APIContextProvider = ({ children }) => {
  const [{ countries, subscribeForm, options }, dispatch] = useReducer(
    apiReducer,
    INITIAL_STATE
  );

  const updateSubscribeForm = (payload) => {
    const { name, value } = payload.target;
    let newSubscribeForm = Object.assign(subscribeForm, {});
    newSubscribeForm[name] = value;

    dispatch({
      type: "UPDATE_SUBSCRIBE_FORM",
      payload: newSubscribeForm,
    });
  };

  const updateOptions = (payload) => {
    dispatch({
      type: "UPDATE_OPTIONS",
      payload,
    });
  };

  const resetForm = (payload) => {
    dispatch({
      type: "RESET_FORM",
    });
  };

  const submitSubscribe = async (event) => {
    event.preventDefault();
    updateOptions({ ...options, onSubmission: true });

    let formdata = new FormData();
    Object.keys(subscribeForm).map((k) => {
      formdata.append(k, subscribeForm[k]);
      return k;
    });

    let message = await SubscribeAsync(formdata);
    message = message.replace(/<\/?[^>]+(>|$)/g, "");

    if (message === "Email address is bounced.") {
      updateOptions({
        ...options,
        onSubmission: false,
        error: message,
      });
      return;
    }
    updateOptions({
      ...options,
      onSubmission: false,
      success: message,
    });
  };

  useEffect(() => {
    const fetchCountries = async () => {
      const countries = await getCountries();
      if (!countries.length) return;
      dispatch({ type: "SET_COUNTRIES", payload: countries });
    };

    const fetchUserCountry = async () => {
      const userCountry = await getUserLocation();
      if (!userCountry) return;
      let newSubscribeForm = Object.assign(subscribeForm, {});
      newSubscribeForm.country = userCountry;
      dispatch({
        type: "UPDATE_SUBSCRIBE_FORM",
        payload: newSubscribeForm,
      });
    };
    fetchCountries();
    fetchUserCountry();
  }, [subscribeForm]);

  const value = {
    countries,
    subscribeForm,
    options,
    updateSubscribeForm,
    submitSubscribe,
    resetForm,
  };

  return <APIContext.Provider value={value}>{children}</APIContext.Provider>;
};

export function useAPIReducer() {
  const context = useContext(APIContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }

  return context;
}
